<template>
  <base-table-wrapper>
    <template #top-buttons>
        <router-link
          v-if="ableToFirmCreate"
          tag="button"
          :to="{ name: 'FirmCreate' }"
          class="btn btn-sm btn-primary float-right mb-1">
          {{$t('buttons.create')}}
        </router-link>
    </template>
    <template #filtering>
      <b-row class="mt-1">
        <b-col class="text-right">
          <b-button v-if="filterStatus" variant="danger" class="btn-sm" v-b-tooltip.hover :title="$t('buttons.clearFilters')" @click="clearFilters"><i class="fa fa-sync"></i><span>{{$t('global.filtersAreSet')}}</span></b-button>
          <button type="button"
                  class="btn btn-sm btn-primary float-right"
                  v-b-tooltip.hover :title="$t('buttons.search')"
                  aria-controls="userdata_search_collapse"
                  v-b-toggle.userdata_search_collapse>
            <i class="fa fa-filter" aria-hidden="true" />
          </button>
        </b-col>
      </b-row>
      <div>
        <b-collapse id="userdata_search_collapse">
          <FirmFiltering ref="firmFiltering" @getPage="getPage($event)" class="mx-1"></FirmFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <span v-else-if="!isLoading && items.length < 1">
        {{$t('views.firm.list.noFirms')}}
      </span>
      <table v-else class="table table-sm table-striped table-hover">
        <thead>
        <tr>
          <th v-if="$store.getters['configuration/mailerLiteStatus']"></th>
          <th></th>
          <th>{{$t('views.firm.list.firmname1')}}</th>
          <th>{{$t('menu.tags.list')}}</th>
          <th>{{$t('views.firm.list.address')}}</th>
          <th v-if="displaySalesRepresentative">{{$t('views.userdata.form.idSalesRepresentative')}}</th>
          <th></th>
          <th style="width: 5%"></th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td v-if="$store.getters['configuration/mailerLiteStatus']" class="text-center">
            <b-form-checkbox
              v-model="selectedUsers"
              :id="'checkbox_'+item['@id']"
              :value="item['@id']"
            ></b-form-checkbox>
          </td>
          <td>
            <span v-if="item.salesOpportunity" v-b-tooltip.hover :title="$t('views.firm.form.idOpportunity') + ': ' + item.salesOpportunity.title" :style="'color: ' + item.salesOpportunity.color" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
            <span v-if="item.status" v-b-tooltip.hover :title="$t('views.firm.form.idStatus') + ': ' + item.status.title" :style="'color: ' + item.status.color" class="h6 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
          </td>
          <td>
            <b-row>
              <b-col cols="10" v-if="item.isCompany === 0">
                <router-link :to="{name: 'ContractorShow', params: { id: item['@id'] }}">
                  <div v-if="item.fullName">{{ item.fullName }}</div>
                </router-link>
              </b-col>
              <b-col cols="10" v-else>
                <router-link :to="{name: 'FirmShow', params: { id: item['@id'] }}">
                  <div v-if="item['firmname1']">{{ item['firmname1'] }}<br></div>
                  <div v-if="item.firmname2 && item.firmname2 !== item.firmname1">{{ item['firmname2'] }}<br></div>
                  {{ $t('views.firm.form.nip') + ': ' + item['nip'] }}
                </router-link>
              </b-col>
            </b-row>
          </td>
          <td>
            <span v-for="tag in item.userDataTags" :key="tag['@id']">
              <b-badge class="mr-2 mb-2 organizationleadtag" pill :style="{'background-color': tag.idTag.color}"><i class="fa fa-tags mr-2"></i>{{tag.idTag.tag}}</b-badge>
            </span>
          </td>
          <td>
            {{ item['postcode'] }}, {{ item['city'] }}, {{ item['street'] }}
          </td>
          <td v-if="displaySalesRepresentative">
            <span v-if="item.idSalesRepresentative">{{ item.idSalesRepresentative.name }} {{ item.idSalesRepresentative.surname }}</span>
          </td>
          <td>
            <div v-if="item.userEmail">{{ item.userEmail }}</div>
            <div v-if="item.contactEmail"><a :href="'mailto: ' + item.contactEmail">{{ item.contactEmail }}</a></div>
            <div v-if="item.userEmail"><a :href="'mailto: ' + item.userEmail">{{ item.userEmail }}</a></div>
            <div v-else-if="item.mobilePhone"><phoneNumberLink :phoneNumber="item.mobilePhone"/></div>
          </td>
          <td>
            <b-dropdown size="sm" variant="link" right text="Right align" toggle-class="text-decoration-none" no-caret>
              <template #button-content>
                <i class="fa fa-bars fa-lg"></i>
              </template>
              <b-dropdown-item v-if="item.isCompany" @click="$router.push({ name: 'FirmShow', params: {id: item['@id']} })">
                <i class="fa fa-search fa-lg"></i>
                {{ $t('buttons.goto') }}
              </b-dropdown-item>
              <b-dropdown-item v-else @click="$router.push({ name: 'ContractorShow', params: {id: item['@id']} })">
                <i class="fa fa-search fa-lg"></i>
                {{ $t('buttons.goto') }}
              </b-dropdown-item>
              <b-dropdown-item v-if="ableToEditFirm(item)" @click="edit(item['@id'])">
                <i class="fa fa-edit fa-lg"></i>
                {{ $t('buttons.edit') }}
              </b-dropdown-item>
              <b-dropdown-item v-if="item.isCompany === 1 && ableToCreateInvoice" @click="showAddInvoiceModal(item['@id'])">
                <i class="fa fa-file-invoice-dollar fa-lg"></i>
                {{ $t('buttons.createInvoice') }}
              </b-dropdown-item>
            </b-dropdown>
          </td>
        </tr>
        </tbody>
      </table>
      <pagination
        v-if="view"
        :view="view"
        :totalItems="totalItems"
        @getPage="getPage($event)"
        @getPageNumber="setCurrentPage($event.page)"
      ></pagination>
      <b-dropdown size="sm" variant="warning" dropright text="Drop-Right" v-if="$store.getters['configuration/mailerLiteStatus']">
        <template #button-content>
          {{ $t('buttons.collectionOperations') }}
        </template>
        <b-dropdown-item @click="addMultipleUsers()"><i class="fa fa-file-check mr-2"></i>{{$t('views.userdata.list.addMultipleUsers')}}</b-dropdown-item>
        <b-dropdown-item v-if="$store.getters['configuration/mailerLiteStatus']" @click="addToMailerLite()"><i class="fa fa-file-check mr-2"></i>{{$t('views.userdata.list.autoAddMailerLiteSubscribers')}}</b-dropdown-item>
      </b-dropdown>
      <div class="float-right">
        <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
          <i class="fal fa-file-spreadsheet"></i>
        </b-button>
        <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
          <i class="fal fa-spinner fa-spin"></i>
        </b-button>
      </div>
      <user-data-add-to-mailer-lite-modal v-if="$store.getters['configuration/mailerLiteStatus']"></user-data-add-to-mailer-lite-modal>
      <invoice-create-modal :id-firm="idFirm"></invoice-create-modal>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import { checkPagePermission, checkPermission, getUserRoles } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'
import FirmFiltering from './components/FirmFiltering/FirmFiltering'
import Pagination from '../../Layout/Pagination'
import InvoiceCreateModal from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/modals/InvoiceCreateModal'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import UserDataAddToMailerLiteModal from '@/components/Dashboard/Views/userdata/component/MailerLite/userDataAddToMailerLiteModal'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  components: {
    PhoneNumberLink,
    UserDataAddToMailerLiteModal,
    Loader,
    FirmFiltering,
    Pagination,
    InvoiceCreateModal,
    BaseTableWrapper
  },

  computed: {
    ableToUpdateUser () {
      return checkPermission('userdatas', 'UserUpdate')
    },
    ableToCreateInvoice () {
      return checkPermission('finances', 'EXSBInvoiceCreate')
    },
    ...mapGetters({
      deletedItem: 'userdata/del/deleted',
      error: 'userdata/list/error',
      items: 'userdata/list/items',
      isLoading: 'userdata/list/isLoading',
      view: 'userdata/list/view',
      totalItems: 'userdata/list/totalItems'
    }),
    ableToFirmCreate () {
      return this.checkRoles('firms', 'FirmCreate')
    },
    ableToFirmUpdate () {
      return this.checkRoles('firms', 'FirmUpdate')
    },
    mobileView () {
      return this.$store.state.mobileView
    },
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    displaySalesRepresentative () {
      for (let i in this.items) {
        if (this.items[i].idSalesRepresentative) {
          return true
        }
      }
      return false
    },
    filterStatus () {
      return JSON.stringify(this.$store.state.filters.firmFilter) !== JSON.stringify(this.$store.state.filters.firmFilterReference)
    }
  },
  beforeCreate () {
    checkPagePermission('firms', 'FirmList')
    if (Object.keys(this.$store.state.filters.firmFilterReference).length === 0) {
      this.$store.state.filters.firmFilterReference = {
        userdata: '',
        name: '',
        surname: '',
        'userDataTags.idTag': [],
        userDataWithoutTag: [],
        status: [],
        salesOpportunity: [],
        idClientType: getUserRoles().roles.includes('ROLE_WHOLESALER') ? 7 : getId(this.$store.getters['configuration/idClientTypeForContractorsView']),
        firmname1: '',
        firmname2: '',
        city: '',
        country: '',
        street: '',
        nip: '',
        postcode: '',
        state: 1,
        isContractor: 1
      }
    }
    if (Object.keys(this.$store.state.filters.firmFilter).length === 0) {
      this.$store.state.filters.firmFilter = JSON.parse(JSON.stringify(this.$store.state.filters.firmFilterReference))
    }
  },

  data () {
    return {
      selectedUsers: [],
      roleOptions: {},
      idFirm: '',
      isAddInvoiceModalVisible: false,
      searchParams: this.$store.state.filters.firmFilter,
      downloadXlsStatus: 0
    }
  },

  created () {
    this.fetchRoles()
    if (this.isWholesaler) {
      this.searchParams.idClientType = 7
    }
    this.getPage(this.getBaseUrl())
    this.channelDeliveries = this.$store.state.Pusher.subscribe('user_datas')
    this.channelDeliveries.bind('user_datas', data => {
      this.getPage(this.view['@id'])
    })
  },

  methods: {
    getBaseUrl () {
      let params = Object.assign({ '_page': this.$store.state.filters.firmFilterCurrentPage }, this.searchParams)
      return addParamsToQuery('user_datas', params)
    },
    async fetchRoles () {
      const response = await new ApiService('client_types?pagination=false&state=1').getResults()
      response.items.forEach(clientType => {
        if (!['ROLE_SUPER_USER', 'ROLE_OWNER'].includes(clientType.roles[0])) {
          this.roleOptions[getId(clientType['@id'])] = clientType.title
        }
      })
    },
    setCurrentPage (page) {
      this.$store.state.filters.firmFilterCurrentPage = page
    },
    clearFilters () {
      if (this.$refs.firmFiltering) {
        this.$refs.firmFiltering.clearFilter()
      }
    },
    ...mapMutations({
      toggleInvoiceCreateModal: 'exsbinvoice/createModal/toggleModal'
    }),
    edit (id) {
      this.$router.push({ name: 'FirmUpdate', params: { id: id } })
    },
    ableToEditFirm (item) {
      if (this.ableToFirmUpdate) {
        return true
      }
      return item.createdBy === parseInt(getUserRoles().id)
    },
    showAddInvoiceModal (id) {
      this.idFirm = id
      this.toggleInvoiceCreateModal()
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    },
    ...mapActions({
      getPage: 'userdata/list/default'
    }),
    addToMailerLite () {
      let users = this.selectedUsers.map(entry => {
        return getId(entry)
      })
      this.$store.state.modals.userdata.addToMailerLite = { show: 1, selectedUsers: users }
    },
    async downloadXLS () {
      this.downloadXlsStatus = 1
      await new ApiService('user_datas/download_xls_userdata', this.searchParams).downloadFile('user_data_firms.xls')
      this.downloadXlsStatus = 0
    }
  }
}
</script>
